import * as PIXI from "pixi.js";
import InfoSlider from "./InfoSlider";
import { rootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import TextureManager from "../../managers/TextureManager";
import { Dims, Coord } from "../../types/Interface";
import addInteractivity from "../../utils/addInteractivity";
import { CustomCursorType } from "../UI/CustomCursor/CustomCursor";


const ARROW_PATH = "/info-slider/arrow.png";

export default class InfoSliderArrows extends PIXI.Container {
  private InfoSlider: InfoSlider = InfoSlider.getInstance();
  private infoSliderDims: Dims;
  private rightArrow: PIXI.Container;
  private leftArrow: PIXI.Container;

  constructor(infoSliderDims: Dims) {
    super();
    this.infoSliderDims = infoSliderDims;
    this.addToCon();
    this.addLeftArrow();
    this.addRightArrow();
  }
  handleArrow = (v: number) => rootEventBus.emit(EnumRootEventBus.setInfoSliderPageWArr, v);
  setArrowInteractivity(arrow: PIXI.Container, interactive: boolean) {
    arrow.interactive = interactive;
    arrow.alpha = interactive ? 1 : .5;
  }

  updateArrowAvaible(eState: "first" | "last" | "middle") {
    if (eState == "first") {
      this.setArrowInteractivity(this.leftArrow, false);
      this.setArrowInteractivity(this.rightArrow, true);
    } else if (eState == "last") {
      this.setArrowInteractivity(this.leftArrow, true);
      this.setArrowInteractivity(this.rightArrow, false);
    } else if (eState == "middle") {
      this.setArrowInteractivity(this.leftArrow, true);
      this.setArrowInteractivity(this.rightArrow, true);
    }
  }
  addLeftArrow() {
    const coord = {
      x: -this.infoSliderDims.width / 2 - 40,
      y: 0
    }
    this.leftArrow = this.generateArrow(coord, false);
  }
  addRightArrow() {
    const coord = {
      x: this.infoSliderDims.width / 2 + 40,
      y: 0,
    }
    this.rightArrow = this.generateArrow(coord, true);
  }
  generateArrow(coord: Coord, isRight: boolean) {
    let texture = TextureManager.getTexture(ARROW_PATH);

    const arrowCon = this.addChild(new PIXI.Container());
    arrowCon.scale.set(.17);

    const Arrow = arrowCon.addChild(new PIXI.Sprite(texture));
    Object.assign(arrowCon, coord);
    Arrow.width = 241;
    Arrow.height = 403;
    Arrow.anchor.set(.5)
    Arrow.rotation = isRight ? 0 : Math.PI;

    const handleDownFunc = () => this.handleArrow(isRight ? 1 : -1);
    addInteractivity(
      Arrow,
      { handleDownFunc },
      CustomCursorType.pointer,
      undefined,
      true
    );
    return arrowCon;
  }

  addToCon() {
    this.InfoSlider.addChild(this);
  }
}